<template>
  <section class="section8-container content-container">

    <div class="pc-content section-content">
      <div class="title-wrapper text-center">
        <h1>{{ $t('home.s8.title') }}</h1>
      </div>
      <div class="clearfix" style="margin-top:140px">
        <div class="float-left app-info" style="max-width:50%;padding-right:30px">
          <div class="clearfix">
            <div class="float-left">
              <img src="../../../assets/home/section8-logo1.png" width="72">
            </div>
            <div class="float-left media-right" style="width: calc(100% - 88px)">
              <div class="name">Genify</div>
            </div>
          </div>
          <div class="desc">{{ $t("home.s8.desc") }}</div>
          <a href="https://genify.xyz" target="_blank" class="btn-background">
            {{ $t("home.s1.b2") }}
          </a>
        </div>
        <div class="float-right" style="max-width:50%;">
          <img src="../../../assets/home/section8-img.png" width="100%">
        </div>
      </div>
      <div class="clearfix" style="margin-top:140px">
        <div class="float-left" style="max-width:50%;">
          <img src="../../../assets/home/section8-img2.png" width="100%">
        </div>
        <div class="float-right app-info" style="max-width:50%;padding-left:30px">
          <div class="clearfix">
            <div class="float-left">
              <img src="../../../assets/home/section8-logo2.png" width="72">
            </div>
            <div class="float-left media-right" style="width: calc(100% - 88px)">
              <div class="name">Tagge</div>
            </div>
          </div>
          <div class="desc">{{ $t("home.s8.desc2") }}</div>
          <a href="https://tagge.xyz/" target="_blank" class="btn-background">
            {{ $t("home.s1.b2") }}
          </a>
        </div>
      </div>
      <div class="clearfix" style="margin-top:140px">
        <div class="float-left app-info" style="max-width:50%;padding-right:30px">
          <div class="clearfix">
            <div class="float-left">
              <img src="../../../assets/home/affine.png" width="72">
            </div>
            <div class="float-left media-right" style="width: calc(100% - 88px)">
              <div class="name">Affine</div>
            </div>
          </div>
          <div class="desc">{{ $t('home.s9.desc') }}</div>
          <a href="https://affine.art" target="_blank" class="btn-background">
            {{ $t("home.s1.b2") }}
          </a>
        </div>
        <div class="float-right" style="max-width:50%;">
          <img src="../../../assets/home/affine-bg.png" width="100%">
        </div>
      </div>
    </div>
  
    <div class="mobile-content section-content">
      <a href="https://genify.xyz" target="_blank" style="display:block">
        <div class="title-wrapper">
          <h1>{{ $t('home.s8.title') }}</h1>
        </div>
        <img src="../../../assets/home/section8-img.png" width="100%">
        <div class="clearfix" style="margin-top: 20px">
          <div class="float-left">
            <img src="../../../assets/home/section8-logo1.png" width="80">
          </div>
          <div class="float-left media-right" style="width: calc(100% - 96px)">
            <div class="name">Genify</div>
            <div class="desc">{{ $t("home.s8.desc") }}</div>
            <a href="https://genify.xyz" target="_blank" class="btn-background">
              {{ $t("home.s1.b2") }}
            </a>
          </div>
        </div>
        <img src="../../../assets/home/section8-img2.png" width="100%" style="margin-top:80px">
        <div class="clearfix" style="margin-top: 20px">
          <div class="float-left">
            <img src="../../../assets/home/section8-logo2.png" width="80">
          </div>
          <div class="float-left media-right" style="width: calc(100% - 96px)">
            <div class="name">Tagge</div>
            <div class="desc">{{ $t("home.s8.desc2") }}</div>
            <a href="https://tagge.xyz/" target="_blank" class="btn-background">
              {{ $t("home.s1.b2") }}
            </a>
          </div>
        </div>
        <img src="../../../assets/home/affine-bg.png" width="100%" style="margin-top:80px">
        <div class="clearfix" style="margin-top: 20px">
          <div class="float-left">
            <img src="../../../assets/home/affine.png" width="80">
          </div>
          <div class="float-left media-right" style="width: calc(100% - 96px)">
            <div class="name">Affine</div>
            <div class="desc">{{ $t('home.s9.desc') }}</div>
            <a href="https://affine.art/" target="_blank" class="btn-background">
              {{ $t("home.s1.b2") }}
            </a>
          </div>
        </div>
      </a>
    </div>
  </section>
</template>
  
  <script>
  export default {
    components: {
    }
  };
  </script>
  
  <style lang="less" scoped>
  .section8-container {
    margin-top: 100px;

    .section-content {
        background: url("../../../assets/home/home-section8-bg.png") center / 100% 100%;
    }
  }

    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .float-left {
        float: left;
    }

    .float-right {
        float: right;
    }

    .app-info {
        padding-top:80px;
    }

    .media-right {
        margin-left: 16px;
    }

    .name {
        line-height: 72px;
        font-weight: 600;
        font-size: 60px;
        color: #1e1e1e;
    }
    .desc {
        margin-top: 30px;
        font-weight: 400;
        font-size: 18px;
        color: #434343;
    }


  .text-center {
    text-align: center;
  }

  .btn-background {
    display: block;
    width: 170px;
    height: 64px;
    line-height: 64px;
    border-radius: 8px;
    margin-top: 40px;
    color: #fff;
    background: #3f4ae1;
    font-size: 22px;
    text-align: center;
  }

  @media (max-width: 500px) {
    .pc-content {
      display: none;
    }
    .mobile-content {
      display: block;
      .title-wrapper {
        margin-bottom: 20px;
        h1 {
          text-align: center;
          font-size: 18px;
          font-family: PingFangHK-Medium, PingFangHK;
          font-weight: 600;
          color: rgba(38, 38, 38, 1);
          line-height: 25px;
        }
        h2 {
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(38, 38, 38, 1);
          line-height: 22px;
        }
      }
      .name {
        font-size: 18px;
        line-height: 24px;
        }
            .desc {
                margin-top: 0;
                font-size: 14px;
            }
            .btn-background {
            width: 120px;
            height: 36px;
            line-height: 36px;
            margin-top: 10px;
            font-size: 14px;
        }
    }
  }
  
  @media (min-width: 501px) {
    .pc-content {
      display: block;
      .title-wrapper {
        h1 {
          font-size: 34px;
          font-family: PingFangHK-Medium, PingFangHK;
          font-weight: 500;
          color: rgba(38, 38, 38, 1);
          line-height: 48px;
        }
        h2 {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(38, 38, 38, 1);
          line-height: 28px;
        }
      }
    }
    .mobile-content {
      display: none;
    }
  }
  </style>
  